import React, { useEffect, useState } from 'react'
import {
  Modal, Card, Col, Row, Table,
} from 'antd'

import { format } from 'date-fns'

import { useRecoilState } from 'recoil'

import { userState } from '../../../store'

import { fetch } from '../../../utils/fetch'

const { Column } = Table

const OrderItemDetail = ({
  visible,
  orderId,
  orderItemId,
  onCancel,
  onShow,
}) => {
  const [bopLoading, setBopLoading] = useState(true)
  const [dataTableBop, setDataTableBop] = useState([])
  const [orderItemDetailBop, setOrderItemDetailBop] = useState([])
  const [orderItemDetailId, setOrderItemDetailId] = useState(0)
  const [visibleBop, setVisibleBop] = useState(false)

  const [user, setUser] = useRecoilState(userState)

  useEffect(() => {
    getOrderItemDetailBop()
  }, [visible])

  const getOrderItemDetailBop = () => {
    setBopLoading(true)
    fetch({
      method: 'GET',
      url: `/order/${orderId}/item/${orderItemId}/detail/bop`,
    }).then((res) => {
      setDataTableBop(res?.data?.data)
      setBopLoading(false)
    })
  }

  const numberWithCommas = (price) => {
    if (!Number.isNaN(price)) return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return '-'
  }

  return (
    <>

      <Modal
        title={`Order Item ${orderItemId}`}
        visible={visible}
        maskClosable={false}
        onCancel={() => { onCancel() }}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        width="90vw"
        centered
      >
        <Row gutter={{ sm: 16, md: 24, lg: 32 }}>
          <Col span={24}>
            <Table
              loading={bopLoading}
              dataSource={dataTableBop}
              size="small"
              scroll={{ x: 1000 }}
              bordered
            >
              <Column ellipsis align="center" title="Detail Id" dataIndex="orderItemDetailId" key="orderItemDetailId" width={80} />
              <Column ellipsis align="center" title="groupName" dataIndex="groupName" key="groupName" width={100} />
              <Column ellipsis align="left" title="Article No" dataIndex="articleNo" key="articleNo" width={100} />
              <Column
                ellipsis
                align="left"
                title="Article Descr"
                dataIndex="articleDescr"
                key="articleDescr"
                width={200}
                render={(text, record) => {
                  if (!user?.role.includes('DESIGNER')) {
                    return (
                      <>
                        <a onClick={() => {
                          setOrderItemDetailId(record.orderItemDetailId)
                          setOrderItemDetailBop(record.orderItemDetailBop)
                          setVisibleBop(true)
                          onCancel()
                        }}
                        >{text}
                        </a>
                      </>
                    )
                  }
                  return (
                    <> {text}</>
                  )
                }}
              />
              <Column ellipsis align="center" title="QTY" dataIndex="itemQty" key="itemQty" width={120} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
              <Column ellipsis align="right" title="Total Price" dataIndex="itemUnitPrice" key="itemUnitPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
              <Column ellipsis align="right" title="Net Price" dataIndex="itemNetPrice" key="itemNetPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
              {(user?.role.includes('ADMIN') || user?.role.includes('MERCH'))
                && <Column ellipsis align="right" title="IDF Price" dataIndex="idfNetPrice" key="idfNetPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />}
              <Column ellipsis align="left" title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            </Table>
          </Col>
        </Row>
      </Modal>

      <Modal
        title={`Order Item Detail ${orderItemDetailId}`}
        visible={visibleBop}
        maskClosable={false}
        onCancel={() => { setVisibleBop(false); onShow() }}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        width="90vw"
        centered
      >
        <Row gutter={{ sm: 16, md: 24, lg: 32 }}>
          <Col span={24}>
            <Table
              // loading={bopLoading}
              dataSource={orderItemDetailBop}
              size="small"
              scroll={{ x: 1000 }}
              bordered
            >
              <Column ellipsis align="center" title="Bop Id" dataIndex="orderItemDetailBopId" key="orderItemDetailBopId" width={80} />
              <Column ellipsis align="center" title="Bop Line" dataIndex="bopLine" key="bopLine" width={80} />
              <Column ellipsis align="center" title="Bop Type" dataIndex="bopType" key="bopType" width={80} />
              <Column ellipsis align="left" title="Bop Code" dataIndex="bopCode" key="bopCode" width={120} />
              <Column ellipsis align="left" title="Bop Descr" dataIndex="bopDescr" key="bopDescr" width={200} />
              <Column ellipsis align="center" title="Qty" dataIndex="bopQuantity" key="bopQuantity" width={80} render={(text) => (text ? String(Number(text).toFixed(2)) : '0.00')} />
              <Column ellipsis align="right" title="ILM Price" dataIndex="bopPrice" key="bopPrice" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
              <Column ellipsis align="right" title="IDF Price" dataIndex="idfPriceBop" key="idfPriceBop" width={100} render={(text) => (text ? numberWithCommas(String(Number(text).toFixed(2))) : '0.00')} />
              <Column ellipsis align="left" title="Created At" dataIndex="createdAt" key="createdAt" width={150} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
            </Table>
          </Col>
        </Row>
      </Modal>
    </>
  )
}

export default OrderItemDetail
